import { render, staticRenderFns } from "./BulletPointsContent.vue?vue&type=template&id=8465c070&scoped=true&"
import script from "./BulletPointsContent.vue?vue&type=script&lang=js&"
export * from "./BulletPointsContent.vue?vue&type=script&lang=js&"
import style0 from "./BulletPointsContent.vue?vue&type=style&index=0&id=8465c070&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8465c070",
  null
  
)

export default component.exports